var Vue = require('vue');
var LanguageSelection = require('./components/LanguageSelection.vue').default;
var RegionSelection = require('./components/RegionSelection.vue').default;

module.exports = function () {
  if (document.getElementById('language-selection')) {
    new Vue({
      el: '#language-selection',
      components: { 'language-selection': LanguageSelection }
    });
  }

  if (document.getElementById('region-selection')) {
    new Vue({
      el: '#region-selection',
      components: { 'region-selection': RegionSelection }
    });
  }
};
